import {openDesignInNewTab} from '@Libraries/open-design-in-new-tab.library';

const EDITOR_POPUP_BLOCKED_GROWL_KEY = 'ai-chat-editor-popup-blocked';

/** Opens the editor in a new tab; outside a click the browser may block it, so a growl link opens it instead. */
export const openEditorInNewTab = (editorUrl: string): void => {
  openDesignInNewTab(editorUrl, {key: EDITOR_POPUP_BLOCKED_GROWL_KEY, text: window.i18next.t('pmwjs_mde_popup_blocked_open_design')});
};
